var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"panel",class:{
    'panel-bottom': _vm.bottom,
  }},[(_vm.title || _vm.hasExtra)?_c('div',{staticClass:"panel-head"},[_c('h3',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),(_vm.hasExtra)?_c('div',{staticClass:"extra"},[_vm._t("extra")],2):_vm._e()]):_vm._e(),_c('div',{staticClass:"panel-body"},[_vm._t("default")],2),_c('div',{staticClass:"panel-footer"},[_vm._t("footer")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }